<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)">
          <v-icon dark> mdi-keyboard-backspace </v-icon>
        </v-btn>
        <br /><br />
        <div class="
            text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4
            primary-text
          ">
          {{ title }}
        </div>
        <br /><br />
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Nombre</th>
                <th class="text-left">Email</th>
                <th class="text-left">Postulacion</th>
                <th class="text-left">Estado</th>
                <th class="text-left">Acciones</th>
              </tr>
            </thead>
            <tbody v-frag v-for="(postulacion, key) in postulaciones" :key="key">
              <tr>
                <td>{{ postulacion.nombre_completo }}</td>
                <td>{{ postulacion.email }}</td>
                <td>{{ postulacion.cargo }}</td>
                <td>

                  <div class="text-center" v-if="postulacion.status == 'rechazado'">

                    <p>
                      <v-alert color="red" dense class="white--text">{{ postulacion.status }}</v-alert>
                    </p>


                  </div>

                  <div class="text-center" v-else-if="postulacion.status == 'aceptado'">
                    <p>
                      <v-alert color="green" dense class="white--text">{{ postulacion.status }}</v-alert>
                    </p>
                  </div>



                </td>
                <td>
                  <div v-if="postulacion.status == null">
                    <v-btn class="mt-3 mb-3" fab dark small color="success" @click="curriculum(postulacion.curriculum)"
                      title="descargar curriculum" v-if="postulacion.curriculum">
                      <v-icon dark> mdi-clipboard-arrow-down-outline </v-icon>
                    </v-btn>

                    <v-btn class="mt-3 mb-3 ml-2" fab dark small color="red"
                      @click="rechazarPostulacion(postulacion.id)" title="rechazar postulacion">
                      <v-icon dark> mdi-window-close</v-icon>
                    </v-btn>

                    <v-btn class="mt-3 mb-3 ml-2" fab dark small color="success"
                      @click="aceptarPostulacion(postulacion.id)" title="aceptar postulacion">
                      <v-icon dark> mdi-checkbox-marked-circle</v-icon>
                    </v-btn>
                  </div>

                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Postulaciones",
  components: {
    CardIeaAppMain,
  },
  data() {
    return {
      title: "Postulaciones",
      postulaciones: [],
    };
  },
  mounted() {
    this.getPostulaciones();
  },
  methods: {
    getPostulaciones() {
      this.$API
        .get({
          url: "postulaciones",
        })
        .then((res) => {
          this.postulaciones = res;
        });
    },
    curriculum(link) {

      window.open(link, '_blank');
    },
    rechazarPostulacion(id) {

      this.$API
        .post({
          url: "rechazarPostulacion/" + id,
        })
        .then(() => {
          this.getPostulaciones();
        });


    }, 
    aceptarPostulacion(id) {

      this.$API
        .post({
          url: "aceptarPostulacion/" + id,
        })
        .then(() => {
          this.getPostulaciones();
        });


    }
  },
};
</script>